module.exports = "https://web-assets.ifttt.com/packs/media/partners/trash-white-60d03f66.svg";